/** A referential list of contact relationships: no tenant, no parameter. */
class FetchContactRelationships {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchContactRelationships;
